import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { EligibilityEvent } from '@models/profileConfiguration/model';

export interface EligibilityEventState extends EntityState<EligibilityEvent, string>, ActiveState {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'EligibilityEvent' })
export class EligibilityEventStore extends EntityStore<EligibilityEventState> {
  constructor() {
    super();
  }
}
